import appApi from "@/api/appApi";

export default {
  async getProfile() {
    const { data } = await appApi.get("user/data");
    return data;
  }
};
